// components
import Scrollbar from '@/components/minimal/scroll-bar';
// @mui
import { Stack, Typography } from '@mui/material';
//
import CommentItem from './CommentItem';

// ----------------------------------------------------------------------

export default function CommentList({ comments }) {
  return (
    <>
      <Scrollbar
        sx={{
          p: 3,
          height: 1,
          overflowY: 'auto',
        }}
      >
        {comments.map((comment) => (
          <CommentItem key={comment.id} comment={comment} />
        ))}
      </Scrollbar>
      {comments.length == 0 && (
        <Stack alignItems="center" justifyContent="center" direction="row" sx={{ height: '100%' }}>
          <Typography
            sx={{
              fontWeight: 'bold',
              fontSize: '29px',
              lineHeight: '35px',
              color: '#151f2f',
            }}
          >
            No comments!
          </Typography>
        </Stack>
      )}
    </>
  );
}
